/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import FormData from "form-data";

import type { ApiRequestOptions } from "./ApiRequestOptions";
import type { OpenAPIConfig } from "./OpenAPI";
import {
  isDefined,
  isStringWithValue,
  base64,
} from "./request-guards";
import { setContentTypeHeader } from "./request-content-type";

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;

/**
 * Resolves a config value that may be static or a function returning a promise.
 *
 * @param options - The current API request options
 * @param resolver - A static value or async resolver function
 * @returns The resolved value
 */
export const resolve = async <T>(
  options: ApiRequestOptions,
  resolver?: T | Resolver<T>
): Promise<T | undefined> => {
  if (typeof resolver === "function") {
    return (resolver as Resolver<T>)(options);
  }
  return resolver;
};

// Helper function to set authorization header
/**
 * setAuthorizationHeader function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 * @param {*} token - Parameter description
 * @param {*} username - Parameter description
 * @param {*} password - Parameter description
 *
 * @returns {*} Return value description
 */
function setAuthorizationHeader(
  headers: Record<string, string>,
  token: string | undefined,
  username: string | undefined,
  password: string | undefined
): void {
  if (isStringWithValue(token)) {
    headers["Authorization"] = `Bearer ${token}`;
    return;
  }

  if (isStringWithValue(username) && isStringWithValue(password)) {
    const credentials = base64(`${username}:${password}`);
    headers["Authorization"] = `Basic ${credentials}`;
  }
}

/**
 * getHeaders function.
 *
 * @param {*} config - Parameter description
 * @param {*} options - Parameter description
 * @param {*} formData? - Parameter description
 *
 * @returns {*} Return value description
 */
export const getHeaders = async (
  config: OpenAPIConfig,
  options: ApiRequestOptions,
  formData?: FormData
): Promise<Record<string, string>> => {
  const token = await resolve(options, config.TOKEN);
  const username = await resolve(options, config.USERNAME);
  const password = await resolve(options, config.PASSWORD);
  const additionalHeaders = await resolve(options, config.HEADERS);
  const formHeaders =
    (typeof formData?.getHeaders === "function" && formData?.getHeaders()) ||
    {};

  const headers = Object.entries({
    Accept: "application/json",
    ...additionalHeaders,
    ...options.headers,
    ...formHeaders,
  })
    .filter(([_, value]) => isDefined(value))
    .reduce(
      (headers, [key, value]) => ({
        ...headers,
        [key]: String(value),
      }),
      {} as Record<string, string>
    );

  setAuthorizationHeader(headers, token, username, password);
  setContentTypeHeader(headers, options.body, options.mediaType);

  return headers;
};

/**
 * getRequestBody function.
 *
 * @param {*} options - Parameter description
 *
 * @returns {*} Return value description
 */
export const getRequestBody = (options: ApiRequestOptions): any => {
  if (options.body) {
    return options.body;
  }
  return undefined;
};
